import {
  createContext,
  ReactNode,
  useContext,
  FC,
  useState,
  useEffect,
} from 'react';

import { SIDEBAR_BREAKPOINT } from '../themes/breakpoints';

type MobileContextType = boolean;

const defaultMobileContext = false;

export const MobileContext =
  createContext<MobileContextType>(defaultMobileContext);

export const MobileProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia(
      `(max-width: ${SIDEBAR_BREAKPOINT - 1}px)`,
    );

    setIsMobile(mediaQuery.matches);

    const handleChange = (event: MediaQueryListEvent) => {
      setIsMobile(event.matches);
    };

    mediaQuery.addEventListener('change', handleChange);

    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, []);

  return (
    <MobileContext.Provider value={isMobile}>{children}</MobileContext.Provider>
  );
};

export const useResponsiveMobile = () => {
  return useContext(MobileContext);
};
